import { Component } from "react";
import CenterBox from "../../components/CenterBox";

import Warning from "../../assets/icons/warning.svg";

import "../../assets/icons/material-ui-icon.css";

class SessionTakenOver extends Component {
    render() {
        return (
            <CenterBox logo cancel="Return to menu" {...this.props}>
                <img src={Warning} className="material-ui-icon" style={{ fontSize: "4.5em" }} alt="Warning" />
                <div className="message-box">
                    You opened the quiz in another tab or device.
                    <br /><br />
                    This session is no longer active.
                </div>
            </CenterBox>
        );
    }
}

export default SessionTakenOver;
